module.exports = "mutation surveyDeleteAnswer($choice:ID!,$user:ID!){deleteAnswer(choice:$choice,user:$user)}"